module.exports = __webpack_public_path__ + "static/img/MW.494bc974.png";